import { useEffect, useState } from "react"
import { getAllTeachers, searchTeachers } from "../utils/requests/teachers"
import {
  getAllArticles,
  getAllCategories,
  searchArticle,
} from "../utils/requests/knowladgebase"
import { isEmpty } from "lodash"

const useCategories = (page: number = 0) => {
  const [loading, setLoading] = useState(false)

  const [categories, setCategories] = useState<KnowladgebaseCategory[]>([])

  const fetchCategories = async () => {
    setLoading(true)
    const categoriesRes = await getAllCategories()
    if (!categoriesRes || isEmpty(categoriesRes)) {
      setLoading(false)
      return
    }

    setCategories(categoriesRes)

    setLoading(false)
  }

  useEffect(() => {
    fetchCategories()
  }, [])
  return { categories, loading }
}

export default useCategories
